export const GET_CUSTOMERS_REQUEST = "GET_CUSTOMERS_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_CUSTOMER = 'INSERT_CUSTOMER'
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER'